import React from "react";
import ASSETS from "@/lib/assets";

// Now uses the client-provided pink hand-drawn crown PNG.
// Falls back to a colored tinted version via filters when needed.
const Crown = ({ size = 32, opacity = 1, className = "" }) => (
  <img
    src={ASSETS.crown}
    alt=""
    aria-hidden="true"
    className={className}
    style={{
      width: size,
      height: "auto",
      opacity,
      display: "inline-block",
      objectFit: "contain",
    }}
  />
);

export default Crown;
